import { render, staticRenderFns } from "./double_arrow_right.vue?vue&type=template&id=f2030260"
import script from "./double_arrow_right.vue?vue&type=script&lang=js"
export * from "./double_arrow_right.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports